/* istanbul ignore file */

// TODO: unit test
import { axios } from '@pukka/auth';
import { MOKA_GOAUTH_SERVICE } from '@pukka/common/constants';
import { assertUtil } from '@pukka/common/utils';
import { ImageUploadFileType } from '@pukka/ui-components';
import { AxiosProgressEvent } from 'axios';

interface ImageData {
  readonly data: string;
  readonly filename: string;
  readonly private_access: boolean;
}

const POST_ITEM_MAIN_IMAGE_API = (outletId: string) => `${MOKA_GOAUTH_SERVICE}/file/v1/outlets/${outletId}/files/sync`;

const UPLOAD_IMAGE_URL = `${MOKA_GOAUTH_SERVICE}/file/v1/outlets`;

const reject = (error: unknown) => {
  let eobj;

  assertUtil.assertErrorHasResponse(error);

  if (error.response) {
    assertUtil.assertErrorHasResponse<{
      data?: {
        errors?: string;
        message?: string;
      };
    }>(error);

    const { data } = error.response;

    if (data?.errors) {
      eobj = new Error(data.errors);
    } else if (data?.message) {
      eobj = new Error(data.message);
    } else {
      assertUtil.assertObjectIsTruthy<{
        message?: string;
      }>(error);

      eobj = new Error(error.message);
    }
  } else {
    assertUtil.assertObjectIsTruthy<{
      message?: string;
    }>(error);

    eobj = new Error(error.message);
  }

  return Promise.reject(eobj);
};

async function postItemMainImage(outletId: number, data: ImageData, updateProgress?: (progress: number) => void) {
  const envMode = import.meta.env.MODE;

  return axios
    .post(POST_ITEM_MAIN_IMAGE_API(`${outletId}`), data, {
      withCredentials: true,
      headers: {
        service: 'inventory',
      },
      // currenlty, uploading is not supported by msw, please update in the future if it is ready
      ...(envMode === 'dev'
        ? {}
        : {
            onUploadProgress(progressEvent: AxiosProgressEvent) {
              const progress = Math.round((progressEvent.progress ?? 0) * 100);

              updateProgress?.(progress);
            },
          }),
    })
    .catch(reject);
}

async function uploadImage(image: ImageUploadFileType<unknown>, outletId: number, updateProgress?: (progress: number) => void) {
  const cleanBase64Image = image.url.replace(/^data:image\/[a-z]+;base64,/, '');

  const { data } = await postItemMainImage(
    outletId,
    {
      data: cleanBase64Image,
      filename: image.name,
      private_access: false,
    },
    updateProgress,
  );

  return {
    ...data,
  };
}

export { uploadImage, UPLOAD_IMAGE_URL };
